import { InjectionToken } from "@angular/core";

export const WINDOW_INJECTION_TOKEN = new InjectionToken<Window>('Window injection token');
export const IS_E2E_TOKEN = new InjectionToken<boolean>('Is E2E injection token');
export const APP_NAME_TOKEN = new InjectionToken<string>('App name injection token');